export const humanReadableShotType = (shotType: string): string => {
  switch (shotType.toLowerCase()) {
    case 'wide_shot':
    case 'wide-shot':
      return 'wide shot';
    case 'closeup':
      return 'close-up';
    default:
      return shotType.replace('_', ' ');
  }
};
